<template>
  <div class="card editable-card">
    <div style="display: flex;">
      <div class="links-body">
        <div class="statBlock">
          <div class="card-header" v-if="$slots.header">
            <slot name="header"></slot>
          </div>
          <div class="card-body">
            <div class="inputs edit-company-card-dialog row">
              <div class="col-lg">
                <div class="select-box">
                  <div>Sector:</div>
                  <el-select
                    class=""
                    size="large"
                    placeholder="Select Sector"
                    v-model="localCompany.sector"
                  >
                    <el-option
                      v-for="option in vals.SECTOR_DEFINES"
                      class=""
                      :value="option"
                      :label="option"
                      :key="option"
                    ></el-option>
                  </el-select>
                </div>
                <div class="select-box">
                  <div>Current Stage:</div>
                  <el-select
                    class=""
                    size="large"
                    placeholder="Select Stage"
                    v-model="localCompany.stage"
                  >
                    <el-option
                      v-for="option in vals.STAGE_DEFINES"
                      class=""
                      :value="option"
                      :label="option"
                      :key="option"
                    ></el-option>
                  </el-select>
                </div>
                <div class="select-box">
                  <div>Status:</div>
                  <el-select
                    class=""
                    size="large"
                    placeholder="Select Status"
                    v-model="localCompany.status"
                  >
                    <el-option
                      v-for="option in vals.STATUS_DEFINES"
                      class=""
                      :value="option"
                      :label="option"
                      :key="option"
                    ></el-option>
                  </el-select>
                </div>

                <div>
                  <div>Rating:</div>

                  <div class="star-rating" :dummy="ratingRefresh">
                    <i
                      class="fa fa-star"
                      @click="changeRating(1)"
                      aria-hidden="true"
                      v-if="localCompany.rating >= 1"
                    ></i>
                    <i
                      class="fa fa-star-o"
                      @click="changeRating(1)"
                      aria-hidden="true"
                      v-if="localCompany.rating < 1"
                    ></i>
                    <i
                      class="fa fa-star"
                      @click="changeRating(2)"
                      aria-hidden="true"
                      v-if="localCompany.rating >= 2"
                    ></i>
                    <i
                      class="fa fa-star-o"
                      @click="changeRating(2)"
                      aria-hidden="true"
                      v-if="localCompany.rating < 2"
                    ></i>
                    <i
                      class="fa fa-star"
                      @click="changeRating(3)"
                      aria-hidden="true"
                      v-if="localCompany.rating >= 3"
                    ></i>
                    <i
                      class="fa fa-star-o"
                      @click="changeRating(3)"
                      aria-hidden="true"
                      v-if="localCompany.rating < 3"
                    ></i>
                    <i
                      class="fa fa-star"
                      @click="changeRating(4)"
                      aria-hidden="true"
                      v-if="localCompany.rating >= 4"
                    ></i>
                    <i
                      class="fa fa-star-o"
                      @click="changeRating(4)"
                      aria-hidden="true"
                      v-if="localCompany.rating < 4"
                    ></i>
                    <i
                      class="fa fa-star"
                      @click="changeRating(5)"
                      aria-hidden="true"
                      v-if="localCompany.rating >= 5"
                    ></i>
                    <i
                      class="fa fa-star-o"
                      @click="changeRating(5)"
                      aria-hidden="true"
                      v-if="localCompany.rating < 5"
                    ></i>
                    <!-- <i class="fa fa-star fa-lg"
                      aria-hidden="true"></i>
                    <i class="fa fa-star fa-lg"
                      aria-hidden="true"></i>
                    <i class="fa fa-star-o fa-lg"
                      aria-hidden="true"></i>
                    <i class="fa fa-star-o fa-lg"
                      aria-hidden="true"></i>
                    <i class="fa fa-star-o fa-lg"
                    aria-hidden="true"></i>-->
                  </div>
                </div>
              </div>
              <div class="col-lg">
                <div class="edit-logo-box">
                  <div>Logo:</div>
                  <div style="margin-bottom: 10px;">
                    <img src="static/img/generic-logo.png" class="edit-company-logo-preview" />
                  </div>
                  <div>
                    <input
                      v-model="localCompany.logo_url"
                      class="url-form-field"
                      placeholder="Url to image..."
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="actionbuttons">
              <button @click="cancel" class="btn btn-info btn-fill btn-wd">Cancel</button>
              <button @click="save" class="btn btn-info btn-fill btn-wd">Save</button>
            </div>
          </div>
          <!--<a href="#" class="edit-button">Edit</a>-->
          <div class="card-footer" v-if="$slots.footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Card from "../Card.vue";
import { vals } from "../../../util";
import { Dialog, Select, Option } from "element-ui";

export default {
  name: "edit-company-card",
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [Dialog.name]: Dialog,
    Card
  },
  computed: {
    vals() {
      return vals;
    }
  },
  props: ["company", "context"],
  data() {
    return {
      localCompany: _.assign({}, this.company),
      ratingRefresh: 0
    };
  },
  methods: {
    cancel() {
      this.$emit("editable-company-card-close", this.context);
    },
    save() {
      this.$emit("editable-company-card-close", this.context, { data: this.localCompany, confirm: true });
    },
    changeRating(rating) {
      this.localCompany.rating = rating;
      this.ratingRefresh++;
    }
  },
  mounted() {
    if (!this.localCompany.rating) this.localCompany.rating = 0;
    this.ratingRefresh++;
  },
  watch: {
    company(newCompany) {
      this.localCompany = _.assign({}, newCompany);
      if (!this.localCompany.rating) this.localCompany.rating = 0;
      this.ratingRefresh++;
    }
  }
};
</script>
<style>
.editable-card {
  height: calc(100% - 30px);
}

/*.edit-button {
    display: block !important;
    width: calc(100% - 10px);
    text-align: center;
    border-top: 1px solid #dfdfdf;
    font-size: 0.8em;
    margin-bottom: 5px;
    margin-left: 5px;
    margin-top: 30px;
}*/

.links-body {
  width: 100% !important;
}

.edit-company-card-dialog .select-primary {
  margin-right: 10px;
}

.select-box {
  margin-bottom: 10px;
}

.edit-logo-box {
  margin-bottom: 10px;
  margin-left: 10px;
}

@media only screen and (max-width: 991px) {
  .edit-logo-box {
    margin-bottom: 0px;
    margin-left: 0px !important;
    width: 100%;
  }
}

.edit-logo-box div {
  margin-bottom: 5px;
}

.select-box div {
  margin-bottom: 5px;
}

.url-form-field {
  border: 1px solid #707070;
  border-radius: 3px;
  padding: 8px;
  height: 40px;
}
.star-rating {
  color: #707070;
  margin-bottom: 20px;
}

.star-rating i {
  margin-right: 4px;
  cursor: pointer;
}

.edit-company-card-dialog .url-form-field {
  width: 100%;
}

.edit-company-logo-preview {
  max-width: 194px;
  width: 100%;
}
</style>